import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${spacing(1.5)};
`;

export const $HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing('lg')};
`;

export const $FileHeader = styled.div`
  ${fontStyle('lg')};

  color: ${({ theme }) => theme.newUI.defaultColors.heading};
`;

export const $CollapsableButton = styled.button`
  display: flex;
  align-items: center;
  z-index: 1;
  cursor: pointer;
  background: transparent;
  border: 0;
  padding: 0;
`;

export const $DocumentsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${spacing('lg')} ${spacing(7)};

  @media ${media.maxWidth.sm} {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: ${spacing('lg')} 0;
  }
`;

export const $NoDocumentAvailable = styled.div`
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  padding: 0 ${spacing('sm')};
`;
